import { API_JWT_BASE_URL } from '../http'

export const SEARCH_DASHBOARD_API = `${API_JWT_BASE_URL}/Dashboard`

export const DASHBOARD_QUERY_KEYS = {
  SEARCH_DASHBOARD: 'searchDashboard'
}
